<template>
  <v-select
    :id="inputId"
    v-model="internalValue"
    :options="countries"
    label="long_name"
    :reduce="reduceCountry"
    :filter="filterCountriesByPrefix"
    :placeholder="placeholder"
    :clearable="clearable"
    :disabled="disabled"
    class="country-select"
  >
    <template #option="option">
      <span class="country-option">
        <span class="country-flag">{{ countryFlagEmoji(option?.short_name) }}</span>
        {{ option?.long_name }}
      </span>
    </template>
    <template #selected-option="option">
      <span class="country-option">
        <span class="country-flag">{{ countryFlagEmoji(option?.short_name) }}</span>
        {{ option?.long_name }}
      </span>
    </template>
  </v-select>
</template>

<script>
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'

export default {
  name: 'CountrySelect',
  components: {
    'v-select': vSelect,
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: undefined,
    },
    value: {
      type: [String, Number],
      default: undefined,
    },
    inputId: {
      type: String,
      default: 'country-select',
    },
    placeholder: {
      type: String,
      default: 'Start typing country name',
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue', 'input'],
  computed: {
    ...mapGetters({
      countries: 'companies/countries',
    }),
    selectedCountryId() {
      const raw = this.modelValue !== undefined ? this.modelValue : this.value
      if (raw == null || raw === '') {
        return null
      }
      const id = Number(raw)
      return Number.isFinite(id) ? id : null
    },
    internalValue: {
      get() {
        return this.selectedCountryId
      },
      set(val) {
        const next = val == null || val === '' ? null : Number(val)
        this.$emit('update:modelValue', Number.isFinite(next) ? next : null)
        this.$emit('input', Number.isFinite(next) ? next : null)
      },
    },
  },
  mounted() {
    this.ensureCountriesLoaded()
  },
  methods: {
    ensureCountriesLoaded() {
      if (!Array.isArray(this.countries) || this.countries.length === 0) {
        return this.$store.dispatch('companies/loadCountries')
      }
      return Promise.resolve(this.countries)
    },
    reduceCountry(country) {
      return country?.id != null ? Number(country.id) : null
    },
    countryFlagEmoji(shortName) {
      const code = String(shortName || '').toUpperCase()
      if (!/^[A-Z]{2}$/.test(code)) {
        return ''
      }
      return String.fromCodePoint(...[...code].map((char) => 127397 + char.charCodeAt(0)))
    },
    filterCountriesByPrefix(options, search) {
      const term = String(search || '').trim().toLowerCase()
      if (!term) {
        return options
      }

      return options.filter((country) => (
        String(country.long_name || '').toLowerCase().startsWith(term)
      ))
    },
  },
}
</script>

<style scoped>
.country-select {
  display: block;
  width: 100%;
}

.country-option {
  display: inline-flex;
  align-items: center;
}

.country-flag {
  margin-right: 0.5rem;
  font-size: 1.15em;
  line-height: 1;
}
</style>
